import {
  withTranslation,
} from 'react-i18next';

import CookiesView from './CookiesView';

const TranslatedComponent = withTranslation()(CookiesView);

const Component = TranslatedComponent;

export default Component;
